import { useEffect, useState } from 'react';

const NAV_ITEMS = [
  { href: '#topics', label: '话题墙' },
  { href: '#brief', label: '今夜速览' },
  { href: '#timeline', label: '时间线' },
  { href: '#dossiers', label: '条线档案' },
  { href: '#comments', label: '围观现场' },
  { href: '#entrances', label: '入口' },
];

const TICKER = [
  '本夜新增 6 条避雷条目',
  '男团解约风波 · 已出最终结果',
  '综艺剪辑争议 · 当天出现反转',
  '独立音乐人重合线 · 仍在冷处理',
  '代言联动删除 · 处理仅用 4 小时',
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const brandTone = scrolled ? 'text-foreground-950' : 'text-background-50';
  const subTone = scrolled ? 'text-foreground-500' : 'text-background-50/70';
  const linkTone = scrolled
    ? 'text-foreground-700 hover:text-primary-600'
    : 'text-background-50/85 hover:text-background-50';

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="bg-primary-500 text-background-50 dark:text-foreground-950">
        <div className="flex h-9 w-full items-center gap-4 overflow-hidden px-4 md:px-8">
          <span className="flex shrink-0 items-center gap-1.5 font-label text-[11px] font-semibold tracking-[0.18em]">
            <span className="h-1.5 w-1.5 rounded-full bg-background-50 animate-pulse-dot dark:bg-foreground-950" />
            深夜更新中
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="animate-ticker flex w-max whitespace-nowrap">
              {TICKER.concat(TICKER).map((item, index) => (
                <span
                  key={`${item}-${index}`}
                  className="mr-10 text-[12px] text-background-50/90 dark:text-foreground-900"
                >
                  {item}
                </span>
              ))}
            </div>
          </div>
          <span className="hidden shrink-0 font-label text-[11px] tracking-[0.14em] text-background-50/80 sm:block dark:text-foreground-900/80">
            NO.{' '}
            {new Date().getMonth() + 1}.{new Date().getDate()}
          </span>
        </div>
      </div>

      <div
        className={`w-full px-4 transition-colors duration-300 md:px-8 ${
          scrolled
            ? 'border-b border-background-200 bg-background-50/95 backdrop-blur'
            : 'border-b border-transparent bg-foreground-950'
        }`}
      >
        <div className="flex h-16 items-center justify-between gap-4 md:h-20">
          <a href="#overview" className="flex items-center gap-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-moon-fill text-lg" />
            </span>
            <span className="flex flex-col leading-none">
              <span className={`font-heading text-lg font-bold tracking-wide md:text-xl ${brandTone}`}>
                深夜黑料
              </span>
              <span className={`mt-1 font-label text-[10px] tracking-[0.28em] ${subTone}`}>
                LATE NIGHT ARCHIVE
              </span>
            </span>
          </a>

          <nav className="hidden items-center gap-7 lg:flex">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className={`text-sm font-medium transition-colors ${linkTone}`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2 md:gap-3">
            <a
              href="#brief"
              className="hidden h-10 items-center gap-2 rounded-md border border-background-300/70 px-4 text-sm font-medium whitespace-nowrap text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 md:flex"
            >
              <i className="ri-search-line text-base" />
              检索条线
            </a>
            <a
              href="#entrances"
              className="flex h-10 items-center gap-2 rounded-md bg-primary-500 px-4 text-sm font-semibold whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
            >
              <i className="ri-megaphone-line text-base" />
              爆料入口
            </a>
            <button
              type="button"
              onClick={() => setOpen((prev) => !prev)}
              aria-label="打开导航菜单"
              className={`flex h-10 w-10 items-center justify-center rounded-md border transition-colors lg:hidden ${
                scrolled
                  ? 'border-background-300/70 text-foreground-800'
                  : 'border-background-50/40 text-background-50'
              }`}
            >
              <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
            </button>
          </div>
        </div>

        {open && (
          <div className="border-t border-background-200 bg-background-50 pb-4 lg:hidden">
            <nav className="flex flex-col">
              {NAV_ITEMS.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="flex items-center justify-between border-b border-background-100 py-3 text-sm text-foreground-700"
                >
                  {item.label}
                  <i className="ri-arrow-right-s-line text-base text-foreground-400" />
                </a>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}